const TOKEN_KEY = 'token'

/**
 * 获取 token
 * @returns {string|null}
 */
export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

/**
 * 设置 token
 * @param {string} token
 */
export function setToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token)
}

/**
 * 删除 token
 */
export function removeToken() {
  sessionStorage.removeItem(TOKEN_KEY)
}

/**
 * 检查是否有 token
 * @returns {boolean}
 */
export function hasToken() {
  return !!getToken()
}
